import { tw } from "@careinfo/tailwind";
import React, { useCallback, useEffect, useState } from "react";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSessionStorage } from "@uidotdev/usehooks";
import { hasValues } from "../../utils/hasValues";
import { IFilterManifest } from "../../types/interface";
import Card from "../Reusable/Card";
import ManifestFilter from "./ManifestFilter";
import { toast } from "react-toastify";
import { usePDFPrintHook } from "@careinfo/layout";
const DarazOrderList = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParms] = useSearchParams();
  const [localState, handleSetState] = useSessionStorage<IFilterManifest>(
    "dispatch-manifest-filter",
    {
      created__range: null,
      vehicle: null,
      driver: null,
      destination_branch: null,
    }
  );
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const [active, setActive] = useState("");
  const { setValue, getValues, watch, reset, control } =
    useForm<IFilterManifest>({
      defaultValues: async () => {
        return {
          vehicle: localState?.vehicle ?? null,
          created__range: localState?.created__range ?? null,
          driver: localState?.driver ?? null,
          destination_branch: localState?.destination_branch ?? null,
        };
      },
    });

  const handleFilterReset = () => {
    reset({
      vehicle: null,
      created__range: null,
      driver: null,
      destination_branch: null,
    });
  };
  const defaultColumns: any = [
    {
      header: "ID",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ cell: { getValue } }) => {
        const value = getValue();
        if (!value) return <p>N/A</p>;

        const date = moment(value).format("YY-MM-DD");
        const time = moment(value).format("HH:mm:ss");

        return (
          <div className={tw`flex flex-col`}>
            <span className={tw`whitespace-nowrap`}>{date}</span>
            <span>{time}</span>
          </div>
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "from_branch.name",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "destination",
      cell: NACell,
    },
    {
      header: "Total Items",
      accessorKey: "total_items",
      cell: ({ getValue }) => <p>{getValue() ?? "0"}</p>,
    },
  ];
  const handleDetailNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };
  const filterParams = watch();

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]); //eslint-disable-line

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);
  const queryParams = params();
  const queryKey = ["daraz-order", ...Object.entries(queryParams || {})];
  return (
    <>
      {/* <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <ManifestFilter
          isFilterVisible={isFilterVisible}
          setValue={setValue}
          getValues={getValues}
          reset={handleFilterReset}
          control={control}
        />
      </Card> */}
      <DataTable
        url={`${APIS.DARAZ_ORDER}`}
        queryKey={`${queryKey}`}
        key={"daraz"}
        // orderSearch={true}
        params={{
          ...params(),
        }}
        handleDetailNavigate={handleDetailNavigate}
        columns={defaultColumns}
        tableName="daraz-list"
        addNewPagePath={"/create"}
      />
    </>
  );
};

export default DarazOrderList;
